import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS } from '../../../../Core/Constant';
import { environment } from 'src/environments/environment';
import { TranslationService } from 'src/app/Service/translation.service';

@Component({
  selector: 'app-physical-fitness',
  templateUrl: './physical-fitness.component.html',
  styleUrls: ['./physical-fitness.component.scss']
})
export class PhysicalFitnessComponent {

  @Input() applicantData: any; // Accept data from parent component
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  submitted = false;
  physicalCapabilityForm!: FormGroup;
  SaveMode = CONSTANTS.SAVE_MODE;
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  genderCode: string | undefined;
  isEditable: boolean = true; // Flag to track if the form is editable


  constructor(private toastr: ToastrService, private api: SevaProfileService, private fb: FormBuilder, public genericValidations: GenericValidationsService, private translation: TranslationService) { }



  ngOnInit(): void {

    if (!this.isPreviewMode) {
      // Execute only when not in preview mode
      this.initializeForm();
      this.getApplicantData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicantData'] && this.applicantData) {

      this.initializeForm();
      this.patchFormWithApplicantData(this.applicantData);
      this.physicalCapabilityForm.disable();
    }
  }


  patchFormWithApplicantData(data: any): void {
    if (data) {
      // Handle any necessary data formatting before patching
      if (data.PregnancyDueDate) {
        data.PregnancyDueDate = this.genericValidations.formatDate(new Date(data.PregnancyDueDate));
      }

      this.physicalCapabilityForm.patchValue(data);
    }
  }

  getApplicantData() {
    this.api.apiCall('PhysicalCapability/GetPhysicalCapibilty', 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%

        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.physicalCapabilityForm.disable();
        } else {
          this.physicalCapabilityForm.enable();
        }

        if (response.Data.PregnancyDueDate) {
          response.Data.PregnancyDueDate = this.genericValidations.formatDate(new Date(response.Data.PregnancyDueDate));
        }

        this.physicalCapabilityForm.patchValue(response.Data);
      }
    })
  }


  initializeForm() {
    this.physicalCapabilityForm = this.fb.group({
      CanClimbStairs: [null, Validators.required],
      ClimbStairsReason: ['', Validators.required],
      CanWalkDistance: [null, Validators.required],
      WalkDistanceReason: ['', Validators.required],
      CanLiftWeight: [null, Validators.required],
      LiftWeightReason: ['', Validators.required],
      CanStandDuration: [null, Validators.required],
      StandDurationReason: ['', Validators.required],
      CanSitDuration: [null, Validators.required],
      SitDurationReason: ['', Validators.required],
      CanBendOver: [null, Validators.required],
      BendOverReason: ['', Validators.required],
      ExerciseType: ['', Validators.required],
      ExerciseFrequency: ['', Validators.required],
      DoExcercise: [null, Validators.required],
      OverallHealth: ['', Validators.required],
      HealthComments: ['', Validators.required],
      IsPregnant: [null, Validators.required],
      PregnancyDueDate: [null,],
      SaveMode: ['', [Validators.required,]],
    });

    const controlMappings = {
      'CanClimbStairs': ['ClimbStairsReason'],
      'CanWalkDistance': ['WalkDistanceReason'],
      'CanLiftWeight': ['LiftWeightReason'],
      'CanStandDuration': ['StandDurationReason'],
      'CanSitDuration': ['SitDurationReason'],
      'CanBendOver': ['BendOverReason'],

      // ========Handle separately===========
      // 'IsPregnant':['PregnancyDueDate']

    };





    const controlMappingsTrue = {
      'IsPregnant': ['PregnancyDueDate'],
      "DoExcercise": ["ExerciseType", "ExerciseFrequency"]
    }

    this.updatePregnancyValidation();

    // Call the service with the isShowOn parameter set to true or false as needed
    this.genericValidations.setupFormListeners(this.physicalCapabilityForm, controlMappings, false);
    this.genericValidations.setupFormListeners(this.physicalCapabilityForm, controlMappingsTrue, true);

  }


  updatePregnancyValidation() {

    const { JWToken, GenderCode } = JSON.parse(localStorage.getItem('userData') || '{}') || {};
    this.genderCode = GenderCode

    const isPregnantControl = this.physicalCapabilityForm.get('IsPregnant');

    if (this.genderCode === 'F') {
      // Apply the required validator if genderCode is 'F'
      isPregnantControl?.setValidators(Validators.required);
    } else {
      // Remove the required validator if genderCode is 'M' or anything else
      isPregnantControl?.clearValidators();
    }

    // Update the validity of the IsPregnant control
    isPregnantControl?.updateValueAndValidity();
  }





  onSubmit(Mode: number): void {

    // this.physicalCapabilityForm.patchValue({
    //   SaveMode: Mode
    // })

    if (!this.physicalCapabilityForm.valid && Mode == this.SaveMode.SAVE) {
      this.submitted = true;


      // Add 'submitted' class manually to all invalid controls
      Object.keys(this.physicalCapabilityForm.controls).forEach((field) => {
        const control = this.physicalCapabilityForm.get(field);
        if (control && control.invalid) {
          control.markAsTouched(); // Ensure ng-touched is triggered
          const element = document.getElementById(field);
          if (element) {
            element.classList.add('submitted'); // Add 'submitted' class to invalid elements
          }
        }
      });

      this.toastr.warning(this.getTranslation('validation.completeAllFields'));


      return
    }



    const formData = this.physicalCapabilityForm.value;

    // Convert DateOfBirth back to Date object before sending to the backend
    if (formData.PregnancyDueDate) {
      formData.PregnancyDueDate = new Date(formData.PregnancyDueDate); // Convert back to Date object
    }

    if (formData.PregnancyDueDate == "") {
      formData.PregnancyDueDate = null
    }

    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.physicalCapabilityForm.value);
    this.addUpdate(cleanedValues, Mode);

  }

  addUpdate(reqBoby: any, Mode: number) {
    reqBoby.SaveMode = Mode;
    this.api.apiCall('PhysicalCapability/savePhysicalCapibilty', 'POST', reqBoby).subscribe((response: any) => {
      console.log('POST response:', response);
      this.toastr.success(response?.Message);
      if (Mode == this.SaveMode.SAVE) {
        this.nextStep.emit();
      } else if (Mode == this.SaveMode.DRAFT) {
        this.getApplicantData();
      }
    });
  }


  goToBack(): void {
    this.previous.emit();
  }

  // Translation helper for template usage
  getTranslation(key: string): string {
    return this.translation.getTranslation(key);
  }

}
